export default {"src":"/_next/static/media/NewHomePageHeroRebranding.98b8cc96.svg","height":747,"width":901,"blurWidth":0,"blurHeight":0};